<template>
  <div class="tab">
    <div
      :class="['tab-item', { active: value === item.value }]"
      :key="item.label"
      @click="onClickItem(item.value)"
      v-for="item in data"
    >{{item.label}}</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [{ label: 'test', value: 0 }, { label: 'test2', value: 1 }],
      required: true
    },
    value: {
      default: '',
      required: true
    }
  },
  methods: {
    onClickItem(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  flex-direction: row;
}
.tab-item {
  cursor: pointer;
  font-size: 14px;
  margin-right: 25px;
  &:last-child {
    margin-right: 0;
  }
}
.active {
  color: #ff4f4f;
}
</style>
